import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import GraficaGenero from './GraficaGenero';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

export default function PieChartGenero({ masculino, femenino, sinregistrar, dataGenero, max, total }) {

    return (
        <>


            <Typography align="center" alignItems="center" style={{ fontWeight: 'bold', fontSize: "34px" }} color='primary'>Población</Typography>

            <Grid container style={{ marginTop: "1%" }} justifyContent='center'>
                <Grid item>
                    <Grid item xs={12} sm container>
                        <Grid item xs container direction="column" spacing={2} >
                            <GraficaGenero femenino={femenino} masculino={masculino} sinregistrar={sinregistrar} />

                        </Grid>
                        <div align="right">
                            <HtmlTooltip
                                title={
                                    <React.Fragment>
                                        <Typography>Descripción</Typography>
                                        <b><br />{"TOTAL:"}</b>{' '}
                                        {"Total de usuarios que han usado la isla en el rango de fechas seleccionado."}
                                        <br />
                                        <b><br />{"SIN REGISTRO:"}</b>{' '}
                                        {"Usuarios que han utilizado la bascula pero aún no han deiligenciado la información de genero"}
                                    </React.Fragment>
                                }
                                placement="right-start"
                            >
                                <HelpOutlineIcon style={{  marginTop: '831%' }}color='primary' />
                            </HtmlTooltip>

                        </div>
                    </Grid>
                </Grid>
            </Grid>


        </>
    );
}